// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import isApiError from "@insite/client-framework/Common/isApiError";
import { ApiParameter, get, post, ServiceResult } from "@insite/client-framework/Services/ApiService";

const baseUrl = "api/cmi/requestQuote";
const getRequestQuoteModalDataUrl = "prefill";
const postRequestQuoteSubmitUrl = "submit";

export interface RequestQuoteApiParameter extends ApiParameter {
    isAuthenticated?: boolean;
    quoteId: string;
    productId: string;
    customerFirstName: string;
    customerLastName: string;
    customerCompanyName: string;
    customerAddressLine1: string;
    customerAddressLine2?: string;
    customerCity: string;
    customerState: string;
    customerZip: string;
    customerPhoneNumber?: string;
    customerEmailAddress: string;
    taxExempt?: boolean;
    taxExemptCertificateNumber?: string;
    orderNote?: string;
}

export async function getRequestQuoteModalDataService(): Promise<ServiceResult<RequestQuoteApiParameter>> {
    try {
        const getRequestQuoteModalDataModel = await get<RequestQuoteApiParameter>(
            `${baseUrl}/${getRequestQuoteModalDataUrl}`,
        );
        return {
            result: getRequestQuoteModalDataModel,
            successful: true,
        };
    } catch (error) {
        if (isApiError(error)) {
            return {
                successful: false,
                errorMessage: error.errorJson.message,
            };
        }
        throw error;
    }
}

export async function submitRequestQuoteService(
    parameter: RequestQuoteApiParameter,
): Promise<ServiceResult<RequestQuoteApiParameter>> {
    try {
        const submitRequestQuoteModel = await post<RequestQuoteApiParameter>(
            `${baseUrl}/${postRequestQuoteSubmitUrl}`,
            parameter,
        );
        return {
            result: submitRequestQuoteModel,
            successful: true,
        };
    } catch (error) {
        if (isApiError(error)) {
            return {
                successful: false,
                errorMessage: error.errorJson.message,
            };
        }
        throw error;
    }
}
